import { IItemKey } from 'api/catalog/models';

export const DEFAULT_COLUMN_VISIBILITY: IItemKey[] = [
  'itemNumber',
  'brandName',
  'upc',
  'hostSystem',
  'description',
  'packSize',
  'isPrivateLabel',
];

export const DISABLED_COLUMN_VISIBILITY: IItemKey[] = [
  'itemNumber',
  'itemAtOtherDcs',
  'additionalDetails',
];

export const UNSORTABLE_COLUMNS: IItemKey[] = [
  'assets',
  'shopDescription',
  'shopReturnPolicy',
  'minShopOrderValue',
  'grossWeight',
  'ingredients',
  'brandName',
  'dcNumber',
  'dcName',
  'promoAtDcNumbers',
  'elasticId',
];

export const ITEM_AVAILABILITY_COLUMNS: IItemKey[] = [
  'itemNumber',
  'hostSystem',
  'dcNumber',
  'dcName',
  'statusCode',
  'isPrivateLabel',
];

export const PAGE_SIZES = [25, 50, 100];
export const DEFAULT_PAGE_SIZE = PAGE_SIZES[0];
